import {t} from "i18next";

import AvailabilityStatusCIrcule from "../../../utilities/AvailabilityStatusCIrcule";
import {STATUS_COLORS} from "../../../utilities/colorConstants";
import {dateTimeUnformatToUnix} from "../../../utilities/dateFormat";
import ToolTip from "../../../utilities/ToolTip";

const PROJECT_STATUS_TOOLTIP_BY_COLOR = {
  [STATUS_COLORS.TRANSPARENT]: t("'Bring to' isn't specified or the project doesn't have any COs"),
  [STATUS_COLORS.RED]: t("The project has at least one expired CO"),
  [STATUS_COLORS.YELLOW]: t("The project has at least one almost expired CO"),
  [STATUS_COLORS.GREEN]: t("The project has at least one valid CO"),
  [STATUS_COLORS.GREY]: t("The project has at least one completed/archived/has directive CO"),
};

const CO_STATUS_TOOLTIP_BY_COLOR = {
  [STATUS_COLORS.TRANSPARENT]: t("'Bring to' isn't specified for CO"),
  [STATUS_COLORS.RED]: t("CO is expired"),
  [STATUS_COLORS.YELLOW]: t("CO is almost expired"),
  [STATUS_COLORS.GREEN]: t("CO is valid"),
  [STATUS_COLORS.GREY]: t("CO is completed/archived/has directive"),
};

export const PROJECT_TABLE_COLUMNS = Object.freeze([
  {
    header: "Status.",
    accessorKey: "statusCircle",
    maxSize: 50,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}} title="">
        <AvailabilityStatusCIrcule
          color={circleColor.getValue()}
          tooltipMessage={PROJECT_STATUS_TOOLTIP_BY_COLOR[circleColor.getValue()] || ""}
        />
      </div>
    ),
  },
  {
    header: "№пп",
    accessorKey: "number",
    maxSize: 50,
  },

  {
    header: "Date from",
    accessorKey: "dateFrom",
    maxSize: 70,
    isSortable: true,
    sortingFn: "sortDate",
  },

  {
    header: "Term P. To",
    accessorKey: "dateTo",
    maxSize: 70,
    isSortable: true,
    sortingFn: "sortDate",
  },
  {
    header: "Project #",
    accessorKey: "projectNumber",
    isSortable: true,
    // size: 100,
  },
  {
    header: "Project Design",
    accessorKey: "projectDesign",
    enableColumnFilter: true,
    filterFn: "includesString",
    // size: 100,
  },
  {
    header: "Sum (n)",
    accessorKey: "planSum",
    // size: ,
  },
  {
    header: "Sum (f)",
    accessorKey: "factSum",
    // size: 100,
  },
  {
    header: "Address",
    accessorKey: "address",
    isSortable: true,
    alignStart: true,
    enableColumnFilter: true,
    filterFn: "includesString",
    size: 370,
    maxSize: 370,
  },
  {
    header: "Manager",
    accessorKey: "projectManager",
    alignStart: true,
  },
]);

export const CO_TABLE_COLUMNS = Object.freeze([
  {
    header: "Status.",
    accessorKey: "statusCircle",
    size: 50,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}} title="">
        <AvailabilityStatusCIrcule
          color={circleColor.getValue()}
          tooltipMessage={CO_STATUS_TOOLTIP_BY_COLOR[circleColor.getValue()] || ""}
        />
      </div>
    ),
  },
  {
    header: "№пп",
    accessorKey: "number",
    size: 50,
    maxSize: 50,
  },
  {
    header: "Date from",
    accessorKey: "startDate",
    isSortable: true,
    size: 120,
    maxSize: 120,
    sortingFn: "sortDate",
  },

  {
    header: "Date to",
    accessorKey: "finalDate",
    isSortable: true,
    size: 120,
    maxSize: 120,
    sortingFn: "sortDate",
  },
  {
    header: "CO №",
    accessorKey: "coNumber",
    isSortable: true,
    size: 120,
    maxSize: 120,
  },
  {
    header: "CO description",
    accessorKey: "coDescription",
    // isSortable: true,
    alignStart: true,
    size: 300,
    maxSize: 300,
    enableColumnFilter: true,
    filterFn: "includesString",
  },
  {
    header: "CO Sum",
    accessorKey: "sum",
    size: 80,
    maxSize: 80,
  },
  {
    header: "Sum (n)",
    accessorKey: "planSum",
    size: 80,
    maxSize: 80,
  },
  {
    header: "Sum (f)",
    accessorKey: "factSum",
    size: 85,
    maxSize: 85,
  },
  {
    header: "%%",
    accessorKey: "persent",
    size: 70,
    maxSize: 70,
  },
  {
    header: "Transport To",
    accessorKey: "factDate",
    cell: ({getValue}) => {
      return (
        <ToolTip
          title={
            dateTimeUnformatToUnix(getValue().finalDate) - dateTimeUnformatToUnix(getValue().bringTo) > 0
              ? "'Bring to' date can`t be lesser than 'Date to'"
              : ""
          }
          bottom
        >
          <span
            className={`${
              dateTimeUnformatToUnix(getValue().finalDate) - dateTimeUnformatToUnix(getValue().bringTo) > 0
                ? "accentedRedTableCell"
                : ""
            }`}
          >
            {getValue().bringTo}
          </span>
        </ToolTip>
      );
    },
    size: 120,
    maxSize: 120,
  },
  {
    header: "Manager",
    accessorKey: "managerP",
    size: 110,
    maxSize: 110,
    alignStart: true,
  },
  {
    header: "Manager CO",
    accessorKey: "managerCO",
    size: 110,
    maxSize: 110,
    alignStart: true,
  },
]);

export const CO_TABLE_COLUMNS_WITHOUT_SUM_P = Object.freeze([
  {
    header: "Status.",
    accessorKey: "statusCircle",
    size: 50,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}} title="">
        <AvailabilityStatusCIrcule
          color={circleColor.getValue()}
          tooltipMessage={CO_STATUS_TOOLTIP_BY_COLOR[circleColor.getValue()] || ""}
        />
      </div>
    ),
  },
  {
    header: "№пп",
    accessorKey: "number",
    size: 50,
    maxSize: 50,
  },
  {
    header: "Date from",
    accessorKey: "startDate",
    isSortable: true,
    size: 120,
    maxSize: 120,
    sortingFn: "sortDate",
  },

  {
    header: "Date to",
    accessorKey: "finalDate",
    isSortable: true,
    size: 120,
    maxSize: 120,
    sortingFn: "sortDate",
  },
  {
    header: "CO №",
    accessorKey: "coNumber",
    isSortable: true,
    size: 120,
    maxSize: 120,
  },
  {
    header: "CO description",
    accessorKey: "coDescription",
    // isSortable: true,
    alignStart: true,
    size: 300,
    maxSize: 300,
    enableColumnFilter: true,
    filterFn: "includesString",
  },
  {
    header: "CO Sum",
    accessorKey: "sum",
    size: 80,
    maxSize: 80,
  },
  // {
  //   header: "Sum (n)",
  //   accessorKey: "planSum",
  //   size: 80,
  //   maxSize: 80,
  // },
  {
    header: "Sum (f)",
    accessorKey: "factSum",
    size: 85,
    maxSize: 85,
  },
  {
    header: "%%",
    accessorKey: "persent",
    size: 70,
    maxSize: 70,
  },
  {
    header: "Transport To",
    accessorKey: "factDate",
    cell: ({getValue}) => {
      return (
        <ToolTip
          title={
            dateTimeUnformatToUnix(getValue().finalDate) - dateTimeUnformatToUnix(getValue().bringTo) > 0
              ? "'Bring to' date can`t be lesser than 'Date to'"
              : ""
          }
          bottom
        >
          <span
            className={`${
              dateTimeUnformatToUnix(getValue().finalDate) - dateTimeUnformatToUnix(getValue().bringTo) > 0
                ? "accentedRedTableCell"
                : ""
            }`}
          >
            {getValue().bringTo}
          </span>
        </ToolTip>
      );
    },
    size: 120,
    maxSize: 120,
  },
  {
    header: "Manager",
    accessorKey: "managerP",
    size: 110,
    maxSize: 110,
    alignStart: true,
  },
  {
    header: "Manager CO",
    accessorKey: "managerCO",
    size: 110,
    maxSize: 110,
    alignStart: true,
  },
]);

export const TODO_TABLE_COLUMNS = Object.freeze([
  {
    header: "№пп",
    accessorKey: "number",
    // size: 50,
  },

  {
    header: "Date from",
    accessorKey: "dateFrom",
    // size: 200,
  },

  {
    header: "Date to",
    accessorKey: "dateTo",
    // size: 250,
  },
  {
    header: "CO №",
    accessorKey: "coNumber",
    // isSortable: true,
    // size: 100,
  },
  {
    header: "CO description",
    accessorKey: "coDescription",
    // isSortable: true,
    // size: 100,
  },
  {
    header: "Sum",
    accessorKey: "coSum",
    // size: 200,
  },

  {
    header: "Manager",
    accessorKey: "managerP",
    // size: 100,
  },
  {
    header: "Manager CO",
    accessorKey: "managerCO",
    // size: 100,
  },
  {
    header: "Status",
    accessorKey: "status",
    size: 50,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
        <AvailabilityStatusCIrcule color={circleColor.getValue()} />
      </div>
    ),
  },
]);
